export default "__VITE_ASSET__3678817a__"